module.exports = __webpack_public_path__ + "img/bul_info_tip.7117baed.svg";